declare global {
  interface Window {
    DP: any; // 👈️ turn off type checking
  }
}

export const getVideoUrl = (idecOrBonus: string) => {
  let paramName = "IDEC";
  let id = idecOrBonus;
  if (idecOrBonus.toString().indexOf("BONUS_") !== -1) {
    id = idecOrBonus.split("_")[1];
    paramName = "bonus";
  }
  if (id !== null) {
    if (window.DP && window.DP.createIframePlayerUrl) {
      const url = window.DP.createIframePlayerUrl({
        [paramName]: id,
        autoStart: true,
      });
      if (url !== null) {
        return url;
      } else {
        return "";
      }
    }
  } else {
    return "";
  }
};
